const $ = require('jquery');

const FilterableTiles = {
	$filterables: [],
	no_results_message: 'Your request came up empty. Please modify your selections and try again.',
	options: [],
	prev_filter_selector: null,
	init() {
		this.$filterables = $('.js-is-filterable');
		if ( this.$filterables.length > 0 ) {
			this.setup();
		}
	},
	setup() {
		$(document).on('filter-tiles', this.onFilter.bind(this));
	},
	onFilter(e, filter_args, $target, source = 'default', options = {} ) {
		if ( $target.length === 0 ) {
			// eslint-disable-next-line no-console
			console.error('Invalid filter target');
			return;
		}
		this.options[source] = options;
		filter_args = this.mergeFilterArgs(filter_args, $target, source);
		const filter_selector = this.buildFilterSelector(filter_args);
		if ( this.prev_filter_selector && this.prev_filter_selector === filter_selector ) {
			return; // Skip - no change
		}
		this.filter($target, filter_selector, filter_args);
		this.prev_filter_selector = filter_selector;
	},
	mergeFilterArgs(filter_args, $target, source) {
		let filter_args_lookup = $target.data('filterargslookup');
		if ( !filter_args_lookup ) {
			filter_args_lookup = {};
		}

		filter_args_lookup[source] = filter_args;
		$target.data('filterargslookup', filter_args_lookup);
		filter_args = {};
		Object.keys(filter_args_lookup).forEach( source => {
			Object.keys(filter_args_lookup[source]).forEach( key => {
				filter_args[key] = filter_args_lookup[source][key];
			});
		});
		return filter_args;
	},
	filter($group, filter_selector) {
		const $isotope_grid = $group.find('.vcex-isotope-grid');
		let $no_results = $group.next('.js-no-results-msg');
		if ( $no_results.length === 0 ) {
			$no_results = $(`<p class="js-no-results-msg">${this.no_results_message}</p>`).hide();
			$group.after($no_results);
		}
		const $visible = $group.find('.vcex-grid-item,.blog-entry').filter(filter_selector);
		if ( $visible.length === 0 ) {
			$no_results.show();
		} else {
			$no_results.hide();
		}
		if ( $isotope_grid.length > 0 ) {
			$isotope_grid.isotope({ filter: filter_selector });
			// Rerun isotope after a brief break to fix layout holes
			window.setTimeout( () => {
				$isotope_grid.isotope({
					filter: filter_selector,
					layoutMode: 'fitRows',
				});
				$group.trigger('after-filter', [ $visible ]);
			}, 500 );
		} else {
			$group.find('.vcex-grid-item,.blog-entry').hide().filter($visible).show();
			$visible.removeClass('col-1 col-2 col-3');
		}
		$group.trigger('after-filter', [ $visible ]);
	},
	buildFilterSelector(filter_args) {
		let filter_selector = '';

		let or_keys = [];
		Object.keys(filter_args).forEach( (key) => {
			let callback = this.filterSelectorCallback;
			if ( typeof filter_args[key] === 'object' ) {
				if ( filter_args[key]['logic'] && filter_args[key]['logic'] === 'or' ) {
					or_keys.push(key);
				} else {
					filter_selector += filter_args[key]['values'].map(x => `[data-${key}*="${x}"]`).join('');
				}
			} else {
				filter_selector += callback(key, filter_args);
			}
		} );

		if ( or_keys.length > 0 ) {
			let selectors = [ ];
			or_keys.forEach(function(or_key) {
				filter_args[or_key]['values'].forEach(function(value) {
					selectors.push(filter_selector + `[data-${or_key}*="${value}"]`);
				});
			});
			filter_selector = selectors.join(',');
		}

		// Handle no filter case
		if ( filter_selector === '' ) {
			return '*';
		}

		return filter_selector;
	},
	filterSelectorCallback(key, filter_args) {
		return filter_args[key];
		// return `[data-${key}*="${filter_args[key]}"]`;
	}
};
$(FilterableTiles.init.bind(FilterableTiles));
